import { render, staticRenderFns } from "./OrthoOnset.vue?vue&type=template&id=d383ef8c&scoped=true"
import script from "./OrthoOnset.vue?vue&type=script&lang=js"
export * from "./OrthoOnset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d383ef8c",
  null
  
)

export default component.exports